import { color } from 'asserts/styles/colors';
import styled from 'styled-components';

const NoDataText = () => {
  return (
    <>
      <Text>NO DATA</Text>
    </>
  );
};

export default NoDataText;

const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 467px;
  font-size: 14px;
  color: ${color.white04};
`;
